import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LanguageIcon from '@mui/icons-material/Language';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import MovieCreation from '@mui/icons-material/MovieCreation';
import CampaignIcon from '@mui/icons-material/Campaign';
import { enProduccionConMemForegroundOnPage } from '../enProduccionConMemReadableText';

const Metrics = () => {
  const theme = useTheme();
  const headingColor = enProduccionConMemForegroundOnPage(theme);
  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) return;
    setViewPortEntered(isVisible);
  };

  const iconProps = { sx: { fontSize: 40, color: headingColor } };

  const metricsData = [
    {
      title: 30000,
      label: 'Visitas mensuales en la plataforma TNO',
      subtitle: 'Comunidad activa y contenido On-Demand (referencia media kit).',
      suffix: '+',
      icon: <LanguageIcon {...iconProps} />,
    },
    {
      title: 1,
      label: 'Capítulo semanal en streaming',
      subtitle: 'Presencia en la grilla de programación TNO en vivo y On-Demand (consultar franja con comercial).',
      suffix: '',
      icon: <MovieCreation {...iconProps} />,
    },
    {
      title: 11,
      label: 'Años de innovación TNO',
      subtitle: 'Respaldo institucional y multiplataforma.',
      suffix: '+',
      icon: <OndemandVideoIcon {...iconProps} />,
    },
    {
      title: 100,
      label: 'Brand safe + conversación de valor',
      subtitle: 'Asociación con autoridad en publicidad, alcance digital y prestigio de marca.',
      suffix: '%',
      icon: <CampaignIcon {...iconProps} />,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium', color: headingColor }}
          gutterBottom
          align="center"
        >
          Alcance
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          align="center"
          gutterBottom
          sx={{ color: headingColor }}
        >
          Los números detrás de En Producción con MEM
        </Box>
        <Typography variant="h6" align="center" color="textSecondary" sx={{ mb: 4 }}>
          Tu mensaje viaja en vivo, queda en la bóveda digital y acompaña a la audiencia cuando repite el episodio.
        </Typography>
      </Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 8 }}>
        <Grid container spacing={2}>
          {metricsData.map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={3}>
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={2}>
                {item.icon}
              </Box>
              <Typography variant="h3" align="center" gutterBottom>
                <Box fontWeight={600}>
                  <VisibilitySensor onChange={(isVisible) => setViewPortVisibility(isVisible)} delayedCall>
                    <CountUp redraw={false} end={viewPortEntered ? item.title : 0} start={0} suffix={item.suffix} />
                  </VisibilitySensor>
                </Box>
              </Typography>
              <Typography align="center" variant="h6" gutterBottom>
                {item.label}
              </Typography>
              <Typography color="text.secondary" align="center" component="p">
                {item.subtitle}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Metrics;
